import { Attachment } from "./Attachment";
import { ProductCatalog } from "./Catalog";
import { MerchandiseCatalogItem } from "./CatalogItem";
import { DownDeposit } from "./Experience";
import { Media } from "./Media";
import { PaymentMethod } from "./Payment";
import { Product, ProductObject } from "./Product";

export interface MerchandiseCatalog extends Omit<ProductCatalog, "items"> {
    items: MerchandiseCatalogItem[];
}

export enum RevenueRecognitionPolicy {
    CREATION = "creation",
    FULFILLMENT = "fulfillment",
}

export enum MerchandiseFulfillmentPolicy {
    IMMEDIATE = "immediate",
    MANUAL = "manual",
}

export enum MerchandiseFulfillmentStatus {
    FULFILLED = "fulfilled",
    PROCESSING_FULFILLMENT = "processing_fulfillment",
    PENDING_FULFILLMENT = "pending_fulfillment",
    PARTIALLY_FULFILLED = "partially_fulfilled",
    RETURNED = "returned",
    DAMAGED = "damaged",
}

export enum MerchandiseFulfillmentType {
    SHIPPING = "shipping",
    IN_STORE = "in_store",
}

export enum MerchandiseInventoryPolicy {
    TRACKED = "tracked",
    UNLIMITED = "unlimited",
}

export enum MerchandiseSource {
    OFFICE = "office",
    CHECKOUT = "checkout",
    KIOSK = "kiosk",
    PLUGIN = "plugin",
}

export enum MerchandiseType {
    PHYSICAL = "physical",
    DIGITAL = "digital",
}

export enum MerchandiseRefundPolicy {
    REFUND_ALLOWED = "refund_allowed",
    REFUND_NOT_ALLOWED = "refund_not_allowed",
}

export enum VariantType {
    SINGLE = "single",
    MULTIPLE = "multiple",
}

export interface WarePreference {
    revenueRecognitionPolicy: RevenueRecognitionPolicy;
    fulfillmentPolicy: MerchandiseFulfillmentPolicy;
    fulfillmentType: MerchandiseFulfillmentType[];
    refundPolicy: MerchandiseRefundPolicy;
    variantType?: VariantType;
    inventoryPolicy?: MerchandiseInventoryPolicy;
}

export interface VariantOption {
    id?: string;
    name: string;
    sequence?: number;
}

export interface VariantGroup {
    id?: string;
    name: string;
    sequence?: number;
    options: VariantOption[];
}

export interface Merchandise extends Omit<Product, "catalog"> {
    object: ProductObject.WARE;
    warePreference: WarePreference;
    allowedSources: MerchandiseSource[];
    type?: MerchandiseType;
    downDeposit?: DownDeposit;
    catalog?: MerchandiseCatalog;
    medias: Media[];
    paymentMethod?: PaymentMethod;
    excerpt: string;
    desc?: string;
    attachments?: Attachment[];
    visible?: boolean;
    variantGroups?: VariantGroup[];
    inventory?: number;
    terms?: string;
    updatesPending?: boolean;
}
